import './editor.css';
import { EditorApp } from './EditorApp';

const canvas = document.querySelector<HTMLCanvasElement>('#app');
if (!canvas) {
  throw new Error('Editor canvas #app missing');
}
const app = new EditorApp(canvas);
void app.init();
